import styled from "styled-components";
const TimelineDiv = styled.div`
  display: grid;
  grid-column: 7 / -1;
  grid-template-rows: 1fr 21px 1fr; 
  row-gap: 2px;
  width:${props=>props.calcWidth}%
`
export default TimelineDiv;